import React, { Component } from 'react';
import { connect } from 'react-redux';
import SocialButtons from './SocialButtons';
import {
  socialSignInReq,
  socialSignUpReq
} from '../../redux/actions/authentication/authentication-action';
import { userAuthenticationRequest } from '../../redux/actions/user-state/user-state-action';
import PropTypes from 'prop-types';
import {
  clearNecessaryLS,
  constructQueryParams,
  getCookie,
  injectIntoDataLayer,
  isIframeWindow
} from '../../utils/library';
import withRouterV6 from '../common/withRouterV6';
import {
  SESSION_STORAGE_ACCOUNT_TYPE,
  SESSION_STORAGE_COUNTRY_CODE,
  SESSION_STORAGE_REFERRAL,
  SESSION_STORAGE_TNC,
  SESSION_STORAGE_REGISTERED_BUSINESS_NAME,
  SESSION_STORAGE_MOBILE_NUMBER,
  SESSION_STORAGE_MOBILE_COUNTRY_CODE,
  SIGNIN_URL,
  SIGNUP_URL,
  USER_REGISTRATION_URL,
  INDIVIDUAL,
  MOBILE_VERIFICATION_URL,
  CONSENT_PERMISSION_URL,
  SESSION_STORAGE_DEEPLINK,
  FAQ_LINK_URL,
  HELP_CENTER,
  DEVICE_ID_COOKIE_NAME,
  EMAIL_VERIFICATION_URL,
  SESSION_STORAGE_IS_SIGNUP_API
} from '../../utils/constants';
import { showMessage } from '../../redux/actions/common-message/message-action';
import { activateLoader, disableLoader } from '../../redux/actions/ui-trigger/ui-trigger-action';
import { API_URL } from '../../utils/config';
import './social-logins.css';
import { GOOGLE_NEW_LOGO_ICON } from '@Images';

class SocialLogins extends Component {
  socialLogin = async (reqData, provider, isSignUp = false, deepLinkValue = null) => {
    if (deepLinkValue) reqData.signup_source = deepLinkValue;
    let isTwoFactorToken = false;
    if (reqData.email) {
      let func = isSignUp ? this.props.socialSignUpReq : this.props.socialSignInReq;
      let response = null;
      try {
        response = await func(reqData, provider);
        if (response?.data?.data) {
          const { emailVerificationRequired = false } = response.data.data;
          if (emailVerificationRequired)
            return this.props.navigate(EMAIL_VERIFICATION_URL, {
              state: {
                emailVerificationData: {
                  ...response.data.data,
                  email: reqData.email,
                  utmCampaigningCookie: response.utmCampaigningCookie,
                  referred_by_referral_code: reqData.referred_by_referral_code,
                  is_term_conditions_accepted: reqData.is_term_conditions_accepted,
                  auth_type: 'GOOGLE_PLUS',
                  deepLinkValue,
                  device_id: reqData.device_id
                }
              }
            });
        }
        if (response && response.data && response.data.success) {
          clearNecessaryLS();

          const responseData = response.data.data;
          const { twoFA, twoFAToken, accountType } = responseData;
          if (responseData?.is_internal === false && !responseData?.partner_permission_granted) {
            //For Partner user
            let state = {
              countryCode: responseData.countryCode,
              isConsentForm: true,
              authorizePartnerToken: responseData.authorizePartnerToken
            };
            if (response.data.data.twoFA) {
              state = { ...state, twoFA, twoFAToken, accountType };
            }
            this.props.disableLoader();
            return this.props.navigate(CONSENT_PERMISSION_URL, { state });
          } else if (twoFA) {
            isTwoFactorToken = true;
            return this.props.navigate(MOBILE_VERIFICATION_URL, {
              state: { twoFA, twoFAToken, accountType }
            });
          } else {
            response = await this.props.userAuthenticationRequest();
            if (response && response.data && response.success) {
              injectIntoDataLayer(this.formID, Object.assign(response.data, { provider }));
              return this.props.navigate(USER_REGISTRATION_URL);
            }
          }
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
      this.props.disableLoader();
      const faqUrlValue = sessionStorage.getItem(FAQ_LINK_URL);
      if (faqUrlValue) return this.props.navigate(HELP_CENTER);
      isTwoFactorToken && window.location.reload();
      !isTwoFactorToken && !isSignUp && this.props.navigate(SIGNUP_URL);
      //this is a case where user tries to login even if that user doesn't have any a/c, then user is redirected to Sign Up
    }
  };
  onSocialClick = async (e, url) => {
    let {
      isSignUp,
      accountType,
      countryCode,
      is_term_conditions_accepted,
      registered_business_name,
      mobile_number,
      mobile_country_code,
      isIndividual,
      touchField,
      setTCError,
      unTouchField
    } = this.props;

    unTouchField('email');
    unTouchField('password');
    if (!isSignUp) window.location.href = url;
    //conditions for individual and corporate sign up
    let requiredFields =
        !accountType ||
        !countryCode ||
        !is_term_conditions_accepted ||
        (!isIndividual && (!registered_business_name || !mobile_number || !mobile_country_code)),
      errorMsges = [];
    //if the requiredFields are not filled, don't redirect and show the resp error msges
    if (requiredFields) e.preventDefault();
    if (!is_term_conditions_accepted) await setTCError();
    if (!accountType) errorMsges.push('Please select account type');
    if (!countryCode) touchField('country_code');

    //only for corp fields
    if (!isIndividual) {
      if (!registered_business_name) touchField('registered_business_name');
      if (!mobile_number) touchField('mobile_number');
      if (!mobile_country_code) touchField('mobile_country_code');
    }
    if (is_term_conditions_accepted && accountType && countryCode) {
      if (!isIndividual) {
        if (registered_business_name && mobile_number && mobile_country_code)
          if (isIframeWindow()) {
            window.parent.location.href = url;
          } else {
            window.location.href = url;
          }
      } else {
        if (isIframeWindow()) {
          window.parent.location.href = url;
        } else {
          window.location.href = url;
        }
      }
    }
  };

  constructor(props) {
    super(props);
    this.formID = `social-${props.isSignUp ? 'signup' : 'login'}`;
  }

  componentDidMount() {
    let {
        sessionStorage,
        location: { search, pathname }
      } = window,
      { isSignUp } = this.props;
    if (search && pathname === SIGNIN_URL) {
      let { token, email, provider, id, error } = constructQueryParams(search);
      if (error) {
        return this.props.showMessage({
          text: decodeURIComponent(error),
          type: 'warning'
        });
      }
      if (!(token && email && provider && id)) {
        return;
      }
      this.props.activateLoader();
      let account_type = sessionStorage.getItem(SESSION_STORAGE_ACCOUNT_TYPE),
        country_code = sessionStorage.getItem(SESSION_STORAGE_COUNTRY_CODE),
        is_term_conditions_accepted = sessionStorage.getItem(SESSION_STORAGE_TNC),
        referred_by_referral_code = sessionStorage.getItem(SESSION_STORAGE_REFERRAL),
        registered_business_name = sessionStorage.getItem(SESSION_STORAGE_REGISTERED_BUSINESS_NAME),
        mobile_number = sessionStorage.getItem(SESSION_STORAGE_MOBILE_NUMBER),
        mobile_country_code = sessionStorage.getItem(SESSION_STORAGE_MOBILE_COUNTRY_CODE),
        deepLinkValue = sessionStorage.getItem(SESSION_STORAGE_DEEPLINK),
        isIndividual = account_type === INDIVIDUAL,
        isSignUpApi = sessionStorage.getItem(SESSION_STORAGE_IS_SIGNUP_API) === 'true';
      const deviceIdFromCookie = getCookie(DEVICE_ID_COOKIE_NAME);
      let payload = {
        email,
        token,
        id,
        ...(deviceIdFromCookie ? { device_id: deviceIdFromCookie } : {})
      };
      if (referred_by_referral_code) payload = { ...payload, referred_by_referral_code };
      if (!isSignUp) {
        //after successful social sign up/in, user is redirected to sing in page where this component
        //is rendered again with the below checks
        sessionStorage.removeItem(SESSION_STORAGE_ACCOUNT_TYPE);
        sessionStorage.removeItem(SESSION_STORAGE_COUNTRY_CODE);
        sessionStorage.removeItem(SESSION_STORAGE_TNC);
        sessionStorage.removeItem(SESSION_STORAGE_REFERRAL);
        registered_business_name &&
          sessionStorage.removeItem(SESSION_STORAGE_REGISTERED_BUSINESS_NAME);
        mobile_number && sessionStorage.removeItem(SESSION_STORAGE_MOBILE_NUMBER);
        mobile_country_code && sessionStorage.removeItem(SESSION_STORAGE_MOBILE_COUNTRY_CODE);
        sessionStorage.removeItem(SESSION_STORAGE_DEEPLINK);
      }
      let requiredFields = account_type && country_code && is_term_conditions_accepted;
      let shouldCheckCompanyFields =
        (!isIndividual && registered_business_name && mobile_number && mobile_country_code) ||
        isIndividual;
      if (isSignUpApi) {
        if (requiredFields && shouldCheckCompanyFields) {
          this.socialLogin(
            {
              ...payload,
              account_type,
              country_code,
              is_term_conditions_accepted,
              registered_business_name,
              mobile_number,
              mobile_country_code
            },
            provider,
            true,
            deepLinkValue
          );
        }
      } else {
        this.socialLogin(payload, provider);
      }
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    let {
      isSignUp,
      accountType,
      countryCode,
      is_term_conditions_accepted,
      valueReferralCode,
      registered_business_name,
      mobile_number,
      mobile_country_code,
      deepLinkValue,
      isSignupApi
    } = props;
    if (!isSignUp) return;
    let { sessionStorage } = window;
    accountType && sessionStorage.setItem(SESSION_STORAGE_ACCOUNT_TYPE, accountType);
    countryCode && sessionStorage.setItem(SESSION_STORAGE_COUNTRY_CODE, countryCode);
    is_term_conditions_accepted &&
      sessionStorage.setItem(SESSION_STORAGE_TNC, is_term_conditions_accepted);
    valueReferralCode && sessionStorage.setItem(SESSION_STORAGE_REFERRAL, valueReferralCode);
    registered_business_name &&
      sessionStorage.setItem(SESSION_STORAGE_REGISTERED_BUSINESS_NAME, registered_business_name);
    mobile_number && sessionStorage.setItem(SESSION_STORAGE_MOBILE_NUMBER, mobile_number);
    mobile_country_code &&
      sessionStorage.setItem(SESSION_STORAGE_MOBILE_COUNTRY_CODE, mobile_country_code);
    deepLinkValue && sessionStorage.setItem(SESSION_STORAGE_DEEPLINK, deepLinkValue);
    sessionStorage.setItem(SESSION_STORAGE_IS_SIGNUP_API, isSignupApi);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.isSignupApi !== this.props.isSignupApi) {
      sessionStorage.setItem(SESSION_STORAGE_IS_SIGNUP_API, this.props.isSignupApi);
    }
  }

  render() {
    return (
      <div className="wrapper">
        <div className="social-logins">
          <SocialButtons
            referenceId="btn-google"
            onClick={(e) => this.onSocialClick(e, `${API_URL}/auth/google`)}
          >
            <img className="social-login-icon" alt={'google-login'} src={GOOGLE_NEW_LOGO_ICON} />
          </SocialButtons>
        </div>
      </div>
    );
  }
}

SocialLogins.propTypes = {
  isSignUp: PropTypes.bool,
  accountType: PropTypes.string,
  countryCode: PropTypes.string,
  is_term_conditions_accepted: PropTypes.bool,
  handleSocialLogin: PropTypes.func,
  txtSocialContent: PropTypes.string,
  txtBtnCancel: PropTypes.string,
  txtBtnConfirm: PropTypes.string,
  highlightReferral: PropTypes.func,
  captureReferralCode: PropTypes.func,
  navigate: PropTypes.func,
  location: PropTypes.object,
  socialSignUpReq: PropTypes.func,
  socialSignInReq: PropTypes.func,
  userAuthenticationRequest: PropTypes.func,
  valueReferralCode: PropTypes.string,
  showMessage: PropTypes.func,
  activateLoader: PropTypes.func,
  disableLoader: PropTypes.func,
  registered_business_name: PropTypes.string,
  mobile_number: PropTypes.string,
  mobile_country_code: PropTypes.string,
  isIndividual: PropTypes.bool,
  setTCError: PropTypes.func,
  touchField: PropTypes.func,
  unTouchField: PropTypes.func,
  deepLinkValue: PropTypes.string,
  isSignupApi: PropTypes.bool
};

const translateSocialLogins = SocialLogins;

export default withRouterV6(
  connect(null, {
    socialSignUpReq,
    userAuthenticationRequest,
    socialSignInReq,
    showMessage,
    activateLoader,
    disableLoader
  })(translateSocialLogins)
);
